export default "__VITE_ASSET__VsBhkvBq__"